import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { Button, Menu, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
// Link as RouterLink,
useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const PortfolioActionsMenu = observer(_ref => {
  var _store$homeDashboardS;
  let portfolioId = _ref.portfolioId,
    selectedPortfolio = _ref.selectedPortfolio,
    menuTriggerExternal = _ref.menuTriggerExternal,
    triggerDeleteModalOpen = _ref.triggerDeleteModalOpen,
    setDeleteModalProps = _ref.setDeleteModalProps,
    triggerRenameModalOpen = _ref.triggerRenameModalOpen,
    setRenameModalProps = _ref.setRenameModalProps,
    handleShowManageAccessModal = _ref.handleShowManageAccessModal,
    selectActionCallback = _ref.selectActionCallback;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const navigate = useNavigate();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const MenuTriggerInternal = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, t('general.to_do')), /*#__PURE__*/React.createElement(Icon, {
      type: "triangle-down"
    }));
  };
  return /*#__PURE__*/React.createElement("span", {
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    key: 'PortfolioActionsMenu' + ((_store$homeDashboardS = store.homeDashboardStore) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.enableShortcutsHintState),
    title: t('Portfolio options'),
    placement: 'top',
    type: 'info'
    // open={store.homeDashboardStore?.enableShortcutsHintState || undefined}
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    className: classes.todoDropdown,
    id: "action-menu-trigger",
    "aria-controls": "action-menu",
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    "aria-label": "resident menu",
    onClick: handleClick,
    state: open ? 'active' : undefined,
    'custom-attribute': '345-PortfolioActionsMenu'
  }, menuTriggerExternal !== undefined ? menuTriggerExternal : /*#__PURE__*/React.createElement(MenuTriggerInternal, null))), /*#__PURE__*/React.createElement(Menu, {
    type: "action-menu",
    id: "portfolio-action-menu",
    MenuListProps: {
      'aria-labelledby': 'action-menu-trigger'
    },
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    elevation: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    }
  }, store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && !(selectedPortfolio !== null && selectedPortfolio !== void 0 && selectedPortfolio.isDefault) && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      handleClose();
      triggerRenameModalOpen(true);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      setRenameModalProps && setRenameModalProps(selectedPortfolio);
    },
    'custom-attribute': '346-PortfolioActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), t('portfolios_properties_page.rename')), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && !store.account.userProfile.isUserPropertyManagerRegular && menuTriggerExternal !== undefined && /*#__PURE__*/React.createElement(Button, {
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      handleClose();
      handleShowManageAccessModal(true, null, selectedPortfolio);
    },
    'custom-attribute': '347-PortfolioActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "user-add"
  }), t('team_page.manage_access')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(Button, {
    id: "addNewProperty",
    variant: "menuAction"
    // component={RouterLink}
    // to={`/new_property?portfolioId=${portfolioId}`}
    ,
    onClick: () => {
      store.addNewProperty.resetStoreToInitValues();
      store.vendors.resetStore();
      navigate("/active_dashboard");
      selectActionCallback({
        entityType: 'portfolio',
        _id: portfolioId,
        prefetchDataOnly: false
      });
      selectActionCallback({
        entityType: 'new_property',
        _id: null,
        prefetchDataOnly: false
      });
    },
    'custom-attribute': '348-PortfolioActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), t('portfolios_properties_page.add_new_property')), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && !(selectedPortfolio !== null && selectedPortfolio !== void 0 && selectedPortfolio.isDefault) && /*#__PURE__*/React.createElement(Button, {
    id: "addNewProperty",
    variant: "menuAction",
    onClick: () => {
      selectActionCallback({
        entityType: 'add_properties_to_portfolio',
        _id: portfolioId,
        prefetchDataOnly: false
      });
      handleClose();
    },
    'custom-attribute': '348-PortfolioActionsMenu-AddProperty'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), t('portfolios_properties_page.add_property')), store.account.featureFlagsStore.getIsMultiAccountAccessEnabled && !(selectedPortfolio !== null && selectedPortfolio !== void 0 && selectedPortfolio.isDefault) && /*#__PURE__*/React.createElement(Button, {
    className: classes.deletePortfolioBtn,
    variant: "menuAction",
    onClick: event => {
      event.stopPropagation();
      handleClose();
      triggerDeleteModalOpen(true);
      setDeleteModalProps({
        selectedPortfolio,
        portfolioId
      });
    },
    'custom-attribute': '349-PortfolioActionsMenu'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('portfolios_properties_page.delete_portfolio')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('portfolios_properties_page.delete_portfolio_subtitle'))))));
});